import {
  E_CARD_SIZE_ID,
  GIANT_CARD_SIZE_ID,
  GIANT_SQUARE_CARD_SIZE_ID,
  LARGE_CARD_SIZE_ID,
  LARGE_SQUARE_CARD_SIZE_ID,
} from '../../../constants'
import { CardSize } from '../types'

export const getCardVariantName = (key: string): CardSize => {
  switch (key.toLowerCase()) {
    case LARGE_CARD_SIZE_ID:
      return CardSize.Large
    case LARGE_SQUARE_CARD_SIZE_ID:
      return CardSize.Large
    case GIANT_CARD_SIZE_ID:
      return CardSize.Giant
    case GIANT_SQUARE_CARD_SIZE_ID:
      return CardSize.Giant
    case E_CARD_SIZE_ID:
      return CardSize.ECard
    default:
      return CardSize.Standard
  }
}
